/* eslint-disable complexity */
import { get } from 'svelte/store'
import { userStore, pageOptsStore } from '@packages/stores'
import { requestReceipt } from '../Payment.service'
import { getAddress } from '@src/passport/blockchain'
import { configStore } from '@src/stores/config'
import { PassportEvents, dispatch } from '@lib/events/events'
import { getClientNameByClientId } from '@lib/clients'
import { evmPaymentRequest } from '@packages/utils/lib/ws/socket-io'
import { TEvmPaymentReturn } from '@packages/utils/types'

export const processPayment = async (stripeTokenId: string) => {
  const config = get(configStore)
  const paymentOpts = get(pageOptsStore)
  const user = get(userStore)
  const userAddress = await getAddress()

  const email = user?.email || user?.pending?.email
  const phone = user?.phone || user?.pending?.phone
  const description =
    'Passport Payment: ' +
    `(${JSON.stringify({
      ...paymentOpts.tokens,
      ...paymentOpts.memberships,
      userAddress,
      chainId: config.chainId,
      email,
      phone,
    })})`

  const clientName = getClientNameByClientId(config.clientId)
  const stripePK = config.stripe.pk[clientName] ?? config.stripe.pk.DEFAULT
  const paymentData = {
    card_token: stripePK.includes('pk_live') ? stripeTokenId : 'tok_visa',
    client: clientName,
    description,
    address: userAddress,
    chain_id: Number(config.chainId),

    ...(paymentOpts.tokens
      ? {
          tokens: paymentOpts.tokens.map(
            ({
              contractAddress,
              tokenId,
              amount,
            }: {
              contractAddress: string
              tokenId: number
              amount: string | number
            }) => ({
              contract_address: contractAddress,
              token_id: tokenId,
              amount,
            }),
          ),
        }
      : {
          memberships: paymentOpts.memberships.map(({ contractAddress }: { contractAddress: string }) => ({
            contract_address: contractAddress,
          })),
        }),
  }

  const res = (await evmPaymentRequest(config.credenza.evmApiUrl, paymentData)) as TEvmPaymentReturn
  if (res.charge?.id) {
    await requestReceipt({ stripeChargeId: res.charge.id, title: paymentOpts.title, subtitle: paymentOpts.subtitle })
    dispatch(PassportEvents.RECEIPT, { stripeChargeId: res.charge.id })
  }
  return res
}
